import { NETWORK_DOMAIN, NETWORK_KEY } from '../../constants'
import { createSelector } from 'reselect'

const isConnectedNetworkSelect = createSelector(state => state[NETWORK_DOMAIN],
  domain => domain[NETWORK_KEY.IS_CONNECTED]
)

export default isConnectedNetworkSelect
